import React, { useEffect, useState } from "react";
import { Builder } from "@builder.io/react";
import { useSelector } from "react-redux";
import { selectProducts } from "../../../../../store/products";
import SpecialCasesTabs from "../../../../../pages/special-cases/specialCasesTabs";
import { useTranslation } from "react-i18next";
const SpecialCasesTabWidget = ({ productConfigs = [] }) => {

  const products = useSelector(state => selectProducts(state));
  const [isLoaded, setIsLoaded] = useState(false);
  const [specialCasesProducts, setSpecialCasesProducts] = useState(new Array(productConfigs.length).fill(0));

  const { i18n } = useTranslation();
  const lang = i18n.language;

const getAllProducts = () => {
    setIsLoaded(true);
    const tempSpecialCasesProducts = new Array(productConfigs.length).fill(null);
    
    products.forEach(item => {
      item.sub_categories.forEach(inner_item => {
        inner_item.products.forEach(inner_item_product => {
          productConfigs.forEach((config, index) => {
            if (inner_item_product.creator === config.creatorId) {
              const productOverrides = { name: config.name };
              if (config.suggestedPrices && config.suggestedPrices.length > 0) {
                productOverrides.suggestedPrices = config.suggestedPrices.map(item => item.price);
              }
              tempSpecialCasesProducts[index] = Object.assign({}, inner_item_product, productOverrides);
            }
          });
        });
      });
    });
    
    setSpecialCasesProducts(tempSpecialCasesProducts.filter(product => product !== null));
  };

  useEffect(() => {
    if (products && Object.keys(products).length && productConfigs.length > 0) {
      getAllProducts();
    }
  }, [products, productConfigs]);

  // Reset loaded state when productConfigs change
  useEffect(() => {
    setIsLoaded(false);
  }, [productConfigs]);



  return (
    <SpecialCasesTabs specialCasesProducts={specialCasesProducts} lang={lang} />
  );
}

Builder.registerComponent(SpecialCasesTabWidget, {
  name: "SpecialCasesTabWidget",
  inputs: [
    {
      name: "productConfigs",
      type: "list",
      subFields: [
        {
          name: "creatorId",
          type: "string",
          required: true,
          helperText: "Creator ID to match against products"
        },
        {
          name: "name",
          type: "string",
          required: true,
          helperText: "Display name for the product"
        },
        {
          name: "suggestedPrices",
          type: "list",
          subFields: [
            {
              name: "price",
              type: "number",
              helperText: "Suggested price amount"
            }
          ],
          helperText: "Array of suggested prices (optional)"
        }
      ],
      defaultValue: [
        {
          creatorId: "SPC-PRG-24-01",
          name: "Special Cases Program Fund",
          suggestedPrices: []
        },
        {
          creatorId: "SPC-PRG-24-04", 
          name: "Hope Line Medical Support",
          suggestedPrices: [{ price: 50 }, { price: 100 }, { price: 250 }]
        },
        {
          creatorId: "SPC-PRG-24-07",
          name: "Home of Hope", 
          suggestedPrices: [{ price: 50 }, { price: 100 }, { price: 250 }]
        }
      ],
      helperText: "Configure product mappings with creator IDs, names and suggested prices"
    }
  ]
});

export default SpecialCasesTabWidget;
